
import { 
    BRAND_REQUEST, 
    BRAND_SUCCESS, 
    BRAND_FAILURE, 
    ADD_BRAND_REQUEST, 
    ADD_BRAND_SUCCESS, 
    ADD_BRAND_FAILURE, 
    DELETE_BRAND_REQUEST, 
    DELETE_BRAND_SUCCESS, 
    DELETE_BRAND_FAILURE, 
    UPDATE_BRAND_REQUEST, 
    UPDATE_BRAND_SUCCESS, 
    UPDATE_BRAND_FAILURE ,
    OUTWARD_BRAND_REQUEST, 
    OUTWARD_BRAND_SUCCESS, 
    OUTWARD_BRAND_FAILURE, 
  } from './actionTypes';
  

import brandService from '../../services/BrandService';
import outWardService from '../../services/outWardService';

// Kategorileri listeleme
export const brandRequest = () => ({
  type: BRAND_REQUEST,
});

export const brandSuccess = (user) => ({
  type: BRAND_SUCCESS,
  payload: user,
});

export const brandFailure = (error) => ({
  type: BRAND_FAILURE,
  payload: error,
});

export const getbrands = (id,token,page,searchTerm) => {

  return async (dispatch) => {
    dispatch(brandRequest());
    try {
      const response = await brandService.getBrandApi(id,token,page,searchTerm);
      dispatch(brandSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(brandFailure(error.response?.data || 'Markalar bulunamadı!'));
      throw error;
    }
  };
  
};


///////////////////////////

// MARKA veri tabanına ekleme
export const addBrandRequest = () => ({
  type: ADD_BRAND_REQUEST,
});

export const addBrandSuccess = (user) => ({
  type: ADD_BRAND_SUCCESS,
  payload: user,
});

export const addBrandFailure = (error) => ({
  type: ADD_BRAND_FAILURE,
  payload: error,
});

export const addBrandAction = (data,token) => {
  return async (dispatch) => {
    dispatch(addBrandRequest());
    try {
      const response = await brandService.addBrandApi(data,token);
      dispatch(addBrandSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(addBrandFailure(error.response?.data || 'MARKA EKLENEMEDİ!'));
      throw error;
    }
  };
  
};

export const deleteBrandRequest = () => ({
  type: DELETE_BRAND_REQUEST,
});

export const deleteBrandSuccess = (user) => ({
  type: DELETE_BRAND_SUCCESS,
  payload: user,
});

export const deleteBrandFailure = (error) => ({
  type: DELETE_BRAND_FAILURE,
  payload: error,
});

export const deleteBrandAction= (id,token) => {

  return async (dispatch) => {
    dispatch(deleteBrandRequest());
    try {
      const response = await brandService.deleteBrandApi(id,token);
      dispatch(deleteBrandSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(deleteBrandFailure(error.response?.data || 'MARKA silinemedi!'));
      throw error;
    }
  };
  
};




export const brandUpdateRequest = () => ({
  type:UPDATE_BRAND_REQUEST,
});

export const brandUpdateSuccess = (user) => ({
  type: UPDATE_BRAND_SUCCESS,
  payload: user,
});

export const brandUpdateFailure = (error) => ({
  type: UPDATE_BRAND_FAILURE,
  payload: error,
});

export const brandUpdate = (data,token) => {

  return async (dispatch) => {
    dispatch(brandUpdateRequest());
    try {
      const response = await brandService.updateBrandApi(data,token);
      dispatch(brandUpdateSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(brandUpdateFailure(error.response?.data || 'MARKA güncellenemedi!'));
      throw error;
    }
  };
};







export const getOutwardBrands = (marketPlaceName,requestBody,token) => {
   
  return async (dispatch) => {
    dispatch({ type: OUTWARD_BRAND_REQUEST });
    try {
      const response = await outWardService.fetchBrand(marketPlaceName,requestBody,token);
  
    
      dispatch({ type: OUTWARD_BRAND_SUCCESS, payload: response });
     
      return response; 
    } catch (error) {
      dispatch({ type: OUTWARD_BRAND_FAILURE, error: error.message });
      return Promise.reject(error); 
    }
  };
};
